import controller from './family-plan-about-dialog.controller';

export default {
  controller,
  template: require('./family-plan-about-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-about-dialog/family-plan-about-dialog.component.ts